import { Injectable, Signal, computed, inject, signal } from '@angular/core';
import { Entity } from '../models/entity.model';
import { Observable, from, of, share, switchMap, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

export const Entities = {
  Summary: 'summary_ui',
  User: 'user_ui',
  InvestmentProjects: 'investment-projects_ui',
  InvestmentProject: 'investment-project_ui',
  Feature: 'feature_ui',
  Notifications: 'notifications_ui',
  Documents: 'documents_ui',
} as const;

export const Permissions = {
  Create: 'CREATE',
  Read: 'READ',
  Update: 'UPDATE',
  Delete: 'DELETE',
  ChangePassword: 'CHANGE-PASSWORD',
} as const;

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  public can(permission: string, entity: string): Signal<boolean> {
    return computed(() => {
      const entities = this.entities();

      if (entity === Entities.Summary) return true;

      return !!(entities as Entity[])
        .filter((x) => x.code === entity)[0]
        ?.permissions.find((y) => y.code === permission);
    });
  }

  public loadPermissions(): Observable<Entity[]> {
    if (this.entities().length) {
      return of(this.entities());
    }

    return of(null).pipe(
      switchMap(() => from(this.API.get(environment.API_NAME, `/permissions/for-user-groups`))),
      tap((entities) => this.entities.set(entities)),
      share(),
    );
  }

  public cleanUp(): void {
    this.entities.update(() => []);
  }

  private readonly API = inject(ApiService);
  private readonly entities = signal<Entity[]>([]);
}
